<script>

import {symbol_by_code} from "./currencies.js";
import axios from "axios";

export default {
  name: "product-table-ll",
  props: {
    items: Array,
    cart: Object,
    previousLlLesson: Object,
  },
  data() {
    return {
      discount: false,
      c_symbol: ''  ,
      lector_options:[]
    }
  },
  async mounted() {
    await this.load_lectors()
    this.c_symbol = symbol_by_code(this.cart.currency_code)
    this.initializeItems()
  },
  methods:{
    async load_lectors(){
      const response = await axios.get('/ll/home/buyable_lectors.json');
      this.lector_options = response.data;
    },
    initializeItems(){
      let needsUpdate = false
      
      for(let i in this.items){
        this.items[i].selected_variant = this.items[i].product.id
        let it = this.items[i]
        
        if (it.qty<4){
          this.items[i].qty=4
          needsUpdate = true
        }

        // Set smart defaults for lector and duration from previous lesson
        if (!it.lector_id && this.previousLlLesson) {
          this.items[i].lector_id = this.previousLlLesson.lector_id
          needsUpdate = true
        }

        if (!it.lesson_minutes) {
          if (this.previousLlLesson) {
            this.items[i].lesson_minutes = this.previousLlLesson.minutes
          } else {
            this.items[i].lesson_minutes = 45  // Default for new students
          }
          needsUpdate = true
        }
        
        // If we set any defaults, update the item to refresh price
        if (needsUpdate) {
          this.changeProduct(it)
        }
      }
    },
    zaokrouhleni(c){
      return Math.round(c)
    },
    perioda(m){
      if (m==1) return 'měsíčně'
      if (m==3) return 'čtvrtletně'
      if (m==6) return 'půlročně'
      if (m==12) return 'ročně'
    },
    changeProduct(it){
      this.$emit('changeProduct', it)
    },
    hasSubscription(){
      for(let i in this.items){
        if (this.items[i].months>1){
          return true
        }
      }
      return false
    }
  },

  watch: {
    cart: {
      handler: function (val) {
        this.c_symbol = symbol_by_code(val.currency_code)
      },
      deep: true
    },

    previousLlLesson: {
      handler: function (val) {
        if (val) {
          this.initializeItems()
        }
      },
      deep: true
    },

    items: {
      handler: function (val) {
        for(let i in this.items){
          this.items[i].selected_variant = this.items[i].product.id
          let it = this.items[i]
          if (it.discounted_price!=it.price_with_tax){
            this.discount = true
          }

          if (it.qty<4){
            this.items[i].qty=4
          }

        }

        this.cart.get_total_price = parseFloat(this.cart.get_total_price)
        this.cart.get_discounted_price = parseFloat(this.cart.get_discounted_price)
        //console.log('ceny,',this.cart.get_total_price , this.cart.get_discounted_price )
      },
      deep: true
    }
  },
}
</script>

<template>
  <table class="item table">
    <thead>
    <tr>
      <th>{{ $t('cart.product') }}</th>
      <th>{{ $t('cart.lector') }}</th>
      <th>{{ $t('cart.lesson_count') }}</th>
      <th>{{ $t('cart.lesson_duration') }}</th>
      <th id="right">{{ $t('cart.amount') }}</th>
      <th v-if="hasSubscription()">{{ $t('cart.period') }}</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="it in items">
      <td>{{ it.product.name }}</td>
      <td>
          <select v-model="it.lector_id" @change="changeProduct(it)" class="form-control mb-2">
            <option v-for="lector in lector_options" :value="lector.id">{{lector.first_name}} {{lector.last_name}}</option>
          </select>
      </td>
      <td>
        <select v-model="it.qty" @change="changeProduct(it)" class="form-control">
          <option :value="4">4 {{ $t('cart.lessons') }}</option>
          <option :value="8">8 {{ $t('cart.lessons') }}</option>
          <option :value="10">10 {{ $t('cart.lessons') }}</option>
          <option :value="20">20 {{ $t('cart.lessons') }}</option>
        </select>

      </td>
      <td>
        <select v-model="it.lesson_minutes" @change="changeProduct(it)" class="form-control">
          <option :value="30">30 {{ $t('cart.minutes') }}</option>
          <option :value="45">45 {{ $t('cart.minutes') }}</option>
          <option :value="60">60 {{ $t('cart.minutes') }}</option>
        </select>
      </td>
      <td id="right">{{ Math.trunc(it.price_with_tax) }} {{c_symbol}}</td>
      <td v-if="hasSubscription()">{{perioda(it.months)}}</td>
    </tr>
    <tr v-if="discount">
      <td> </td>
      <td> Sleva </td>
      <td> </td>
      <td id="right">- {{ zaokrouhleni(cart.get_total_price - cart.get_discounted_price) }} {{c_symbol}}  </td>
      <td v-if="hasSubscription()"> </td>
    </tr>
    </tbody>
    <tfoot v-if="discount">
    <tr id="discount-price">
      <td> </td>
      <td> <b>Cena po slevě</b> </td>
      <td> </td>
      <td id="right"> <b>{{ zaokrouhleni(cart.get_discounted_price) }} {{c_symbol}} </b> </td>
      <td v-if="hasSubscription()"></td>
    </tr>
    </tfoot>
  </table>

</template>

<style scoped>

#right {
  text-align: right;
}

</style>